'use client';
import { useRef, useState, useMemo, useEffect } from 'react';
import { isBrowser } from '@s7/platform';

var defaultState = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    top: 0,
    left: 0,
    bottom: 0,
    right: 0
};
var useResizeObserver = function() {
    var frameID = useRef(0);
    var ref = useRef(null);
    var _useState = useState(defaultState), rect = _useState[0], setRect = _useState[1];
    var observer = useMemo(function() {
        return isBrowser() ? new ResizeObserver(function(entries) {
            var entry = entries[0];
            if (entry) {
                cancelAnimationFrame(frameID.current);
                frameID.current = requestAnimationFrame(function() {
                    if (ref.current) {
                        setRect(entry.contentRect);
                    }
                });
            }
        }) : null;
    }, []);
    useEffect(function() {
        if (ref.current) {
            observer == null ? void 0 : observer.observe(ref.current);
        }
        return function() {
            observer == null ? void 0 : observer.disconnect();
            if (frameID.current) {
                cancelAnimationFrame(frameID.current);
            }
        };
    }, [
        ref.current
    ]);
    return [
        ref,
        rect
    ];
};

export { useResizeObserver };
